<div class="m-0 p-0 w-full flex items-center">
  <pre class="hidden">{{ fleetOrder() | json }}</pre>
  @if ((fleetOrder()?.complete || 0) === 0) {
    <div class="flex items-center min-w-8 max-w-8">
      <ism-svg [name]="'plusCircle'" [classString]="'w-8 h-8 flex items-center text-green-600'"></ism-svg>
      <!-- <img width="32px" [src]="'/assets/_icons/circle_with_plus.svg'" /> -->
    </div>
  }
  <!-- -->
  @else if ((fleetOrder()?.complete || 0) === 1) {
    <div class="flex items-center justify-center min-w-8 max-w-8">
      <ism-svg [name]="'checkCircle'" [classString]="'w-8 h-8 flex items-center text-blue-600'"></ism-svg>
      <!-- <img width="32px" [src]="'/assets/_icons/checkmark.png'" /> -->
    </div>
  }
  <!-- -->
  @else {
    <div class="flex items-center min-w-8 max-w-8">
      <ism-svg [name]="'xCircle'" [classString]="'w-8 h-8 flex items-center text-yellow-600'"></ism-svg>
      <!-- <img width="32px" [src]="'/assets/_icons/Xmark.png'" /> -->
    </div>
  }
  <div class="ml-2 w-full font-extralight">
    {{ fleetOrder()?.asString }}
  </div>

  <!-- @if(fleetOrder().code === 161 && fleetOrder().stage === 2 && determineProbePath()) {
  <button class="px-4 btn" type="button" (click)="editOrder(fleetOrder)">Define Path</button>
  } -->

  @if (fleetOrder()?.code === 161 && (fleetOrder()?.stage === 2 || fleetOrder()?.stage === 3)) {
    <a data-text="Opens iBM (ProbeMode) in another tab" target="_blank" type="button" class="tooltip-tr pr-4 px-4 text-1.25 text-center btn whitespace-nowrap" href="/canvasTools/ibm.html?foid={{ fleetOrder()?._id }}"> iProbePath </a>
  }
</div>
